import React, { useState, useEffect } from "react";
import { CssBaseline, Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "./components/Sidebar";
import LoginMui from "./pages/Login/Login";
import Dashboard from "./pages";
import Organizations from './pages/organizations';
import Brands from './pages/brands';
import Properties from './pages/properties';
import Hotels_contact from './pages/properties/hotels_contact';
import Channels from "./pages/channels";
import Reports from "./pages/Reports";
import Contacts from "./pages/Contacts";
import Plans from "./pages/Rate Plans";
import Booking from "./pages/booking";
import Hotels from "./pages/hotel";
import Rate_Plan_Channel from "./pages/Rate Plan Channel";
import RoomTypes from './pages/RoomTypes';
import BookingSummary from './pages/BookingSummary';
import BookingActivityList from './pages/BookingActivityList';
import BookingActivityPools from './pages/BookingActivityPools/index';
import BookingInventoryPools from './pages/BookingInventoryPools/index';
import RoomAmenities from './pages/RoomAmenities';
import HotelAmenityMapping from './pages/HotelAmenityMapping';
// Change this line
import Activity from './pages/Activities';  // Changed from './pages/Activity'
import HotelRewardPoints from './pages/HotelRewardPoints'
import HotelActivityMapping from './pages/HotelActivityMapping'
function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" />;
}

function AppContent() {
  const [open, setOpen] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    // Redirect to login page when app starts
    if (location.pathname === '/') {
      navigate('/login');
    }
    // If no token, force to login page
    if (!token && location.pathname !== '/login') {
      navigate('/login');
    }
  }, []);

  // Show only login page if not authenticated
  if (!token) {
    return (
      <Box sx={{ display: "flex", height: "100vh", width: "100vw" }}>
        <Routes>
          <Route path="/login" element={<LoginMui />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Box>
    );
  }

  // Show main application with sidebar if authenticated
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Sidebar open={open} handleDrawerToggle={() => setOpen(!open)} />
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Routes>
          <Route path="/login" element={<Navigate to="/hotel" replace />} />
          <Route path="/" element={<Navigate to="/hotel" replace />} />
          <Route path="/hotel" element={<Hotels />} />
          <Route path="/roomtypes" element={<RoomTypes />} />
          <Route path="/room-amenities" element={<RoomAmenities />} />
          <Route path="/hotel-amenity-mapping" element={<HotelAmenityMapping />} />
          <Route path="/organizations" element={<Organizations />} />
          <Route path="/HotelRewardPoints" element={<HotelRewardPoints />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/hotels_contact" element={<Hotels_contact />} />
          <Route path="/channels" element={<Channels />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/roomtype" element={<RoomTypes />} />
          <Route path="/HotelActivityMapping" element ={<HotelActivityMapping/>}/>
          // Make sure the route path matches
          <Route path="/activity" element={<Activity />} />
         <Route path="/Rate paln channel" element={<Rate_Plan_Channel />} />
          <Route path="/bookingsummary" element={<BookingSummary />} />
          <Route path="/bookingactivities" element={<BookingActivityList />} />
          <Route path="/bookingactivitypools" element={<BookingActivityPools />} />
          <Route path="/bookinginventorypools" element={<BookingInventoryPools />} />
        </Routes>
      </Box>
    </Box>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
